<mat-form-field appearance="outline" class="flex-1">
  <mat-label>{{label()}}</mat-label>
  <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="userAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
  <div matSuffix="" class="flex items-center">
    @if (isLoadingUsers) {
      <mat-spinner diameter="14" class="mx2"></mat-spinner>
    } @else {
      <button type="button" (click)="refreshUsers(); $event.stopPropagation();" mat-icon-button="" color="primary">
        <mat-icon>refresh</mat-icon>
      </button>
    }
  </div>
  <mat-autocomplete autoActiveFirstOption="" #userAutoComplete="matAutocomplete" [displayWith]="displayWithUser">
    @if (required() === false) {
      <mat-option [value]="null">
        <span translate="">None</span>
      </mat-option>
    }
    @for (user of usersFiltered; track user) {
      <mat-option [value]="user">
        {{user.initials}}
        @if (user.middleName !== null && user.middleName.trim().length > 0) {
          {{user.middleName}}
        }
      {{user.surname}}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>